import { render, staticRenderFns } from "./ElementTag.vue?vue&type=template&id=645546d6&"
import script from "./ElementTag.vue?vue&type=script&lang=js&"
export * from "./ElementTag.vue?vue&type=script&lang=js&"
import style0 from "./ElementTag.vue?vue&type=style&index=0&id=645546d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports